import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as myGlobal from 'global';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class LoginService {

    constructor( private http: HttpClient, private cookieService: CookieService ) {
    }

    postSignIn( model: any ) {
        const postJSON = {
            'username': model.username,
            'password': model.password
        };
        const headers = new HttpHeaders( {
            [ myGlobal.CONTENT_TYPE ]: 'application/json',
            [ myGlobal.PROVIDER ]: this.cookieService.get( 'Provider' )
        } );
        const options = {
            headers: headers
        };
        return this.http.post( myGlobal.AUTHENTICATION + '/' + 'login', postJSON, options );
    }

    postuserVerify( userVerify ) {
        const headers = new HttpHeaders( {
            [ myGlobal.CONTENT_TYPE ]: 'application/json'
        } );
        const options = {headers: headers};
        return this.http.post( myGlobal.USER_VERIFICATION + '/' + 'confirm_email', userVerify, options );
    }

    postResetPassword( passwordReset ) {
        const headers = new HttpHeaders( {
            [ myGlobal.CONTENT_TYPE ]: 'application/json'
        } );
        const options = {headers: headers};
        return this.http.post( myGlobal.AUTHENTICATION + '/' + 'confirm_password', passwordReset, options );
    }

    getAssessmentViewResult( userid, propertyid, assessmentContextId ) {
        return this.http.get( myGlobal.VIEWRESULT + '/rule/' + userid + '/ ' + propertyid + '/' + assessmentContextId );
    }
}


